module.exports = __webpack_public_path__ + "static/img/08102254pa94.bfd470ef.jpg";